import React, { useEffect, useState } from "react";
import styles from './partList.module.css';
import styless from '../../../component/bomComps/BomListTable/bomListTable.module.css';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Button, Grid,

} from "@mui/material";
import { Close, EditPart, Edituser, Leaf, Payment, Pdf, Refresh, View } from "../../../Svg";
import NestedUserHeader from "../../../component/reusable/NestedUserHeader";
import { styled } from '@mui/material/styles';
import Cards from "../../../component/reusable/Cards";
import BomListTable from "../../../component/bomComps/BomListTable/BomListTable";
import SuppliersQuote from "../SuppliersQuote";
import BomVendorPicker from "../BomVendorPicker";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { bomDetailsThunk, createbomQuoteThunk, getMatchedProductsThunk, getSuppliersThunk, updateProductFromScheduleThunk } from "../../../redux/bomSlice";
import { fomateDate } from "../../../utils/fomateDate";
import { toast } from "react-toastify";


const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  fontSize: '0.875rem',
  color: '#512DA8',
  fontSize: '14px',
  fontWeight: '600 !important',
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));



const BomQuote = () => {
  const { loading, macthedProducts, suppliers } = useSelector((state) => state.bom)
  const { refresh, bomEnquiryDetails } = useSelector((state) => state.bom);
  const navigate = useNavigate()
  const location = useLocation();
  const dispatch = useDispatch()
  const [editingProduct, setEditingProduct] = useState(null);
  const [newPartNumber, setNewPartNumber] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(null)
  const { id } = useParams()
  const [showSupplier, setShowSupplier] = useState(false)
  const [selectedParts, setSelectedParts] = useState([])
  const [showVendorPicker, setShowVendorPicker] = useState(false)


  const [productData, setProductData] = useState([]);



  useEffect(() => {
    setProductData(bomEnquiryDetails?.partList)
  }, [bomEnquiryDetails])


  useEffect(() => {
    dispatch(bomDetailsThunk(id))
  }, [refresh])


  useEffect(() => {
    dispatch(getMatchedProductsThunk(productData))
  }, [productData])


  const handleChange = (index, field, value) => {
    const updatedProducts = [...productData];
    updatedProducts[index] = { ...updatedProducts[index], [field]: value }; // Add field dynamically
    setProductData(updatedProducts);
  };

  // Delete a product
  const handleDelete = (index) => {
    setProductData(productData?.filter((_, i) => i !== index));
  };

  // Refresh a row (reset the input fields)
  const handleRefresh = (index) => {
    const product = productData[index];
    const isExit = bomEnquiryDetails?.partList?.find((i) => i?.partNumber == product?.partNumber)
    setProductData((prevProducts) => {
      const updatedProducts = [...prevProducts];
      updatedProducts[index] = { _id: prevProducts[index]._id, productNumber: prevProducts[index]?.productNumber, quotePrice: isExit?.quotePrice, moq: isExit?.moq };
      return updatedProducts;
    });
  };

  // console.log(productData);

  const handleCancel = () => {
    bomEnquiryDetails?.partList?.map((i) => {
      setProductData(prevData =>
        prevData.map(product =>
          product.productNumber === i?.productNumber
            ? { ...product, quotePrice: i?.quotePrice, moq: i?.moq }
            : product
        )
      );

    })
  }


  const handleSubmit = () => {
    const formattedData = productData.map((product, index) => {
      const manufacturer = macthedProducts[index]
      return ({
        productNumber: product?.productNumber,
        partId: product._id,
        quotePrice: product.quotePrice || 0,
        moq: product.moq || 0,
        manufacturer: manufacturer?.product?.productOverview?.manufacturer[0]?.name || product?.manufacturer,
      })
    }
    );

    const finaldata = {
      id: bomEnquiryDetails?._id,
      data: formattedData
    }
    dispatch(createbomQuoteThunk(finaldata))
  };


  const handleView = (index) => {
    setSelectedIndex(index)
    const product = productData[index];
    dispatch(getSuppliersThunk(`?productNumber=${product?.productNumber}&quantity=${product?.quantity}&enquiryId=${bomEnquiryDetails?._id}&manufacturer=${product?.manufacturer}`))
    setShowSupplier(true)
  }


  const handleProductEdit = (index) => {
    const product = productData[index];
    const manufacturer = macthedProducts[index]

    const data = {
      id: bomEnquiryDetails?._id,
      partId: product._id,
      productNumber: product?.productNumber,
      manufacturer: manufacturer?.product?.productOverview?.manufacturer[0]?.name || product?.manufacturer,
      quotePrice: product.quotePrice || 0,
      moq: product.moq || 0,
    }
    dispatch(updateProductFromScheduleThunk(data))
  }



  const updatedProducts = macthedProducts?.map(product => {
    const foundProduct = productData?.find(p => p?.productNumber === product?.productNumber);
    return {
      ...product,
      quantity: foundProduct ? foundProduct.quantity : 0
    };
  });


  const handleToggleSelect = (productNumber) => {
    setSelectedParts((prev) => prev.includes(productNumber)
      ? prev.filter((p) => p !== productNumber)
      : [...prev, productNumber]);
  };

  const handleToggleSelectAll = (checked) => {
    setSelectedParts(checked ? (updatedProducts || []).map((p) => p?.productNumber).filter(Boolean) : []);
  };

  const handleOpenVendorPicker = () => {
    if (!selectedParts.length) {
      toast.error('Please select at least one product');
      return;
    }
    setShowVendorPicker(true);
  };

  const partsToSend = (productData || [])
    .filter((p) => selectedParts.includes(p?.productNumber))
    .map((p) => {
      const idx = productData.findIndex((x) => x?.productNumber === p?.productNumber);
      const matched = macthedProducts?.[idx];
      return {
        productNumber: p?.productNumber,
        quantity: p?.quantity,
        manufacturer: matched?.product?.productOverview?.manufacturer?.[0]?.name || p?.manufacturer,
      };
    });

  const handleSelectAlternate = (originalItem, alternateProductNumber) => {

    setProductData(prevData => {
      const isAlreadyExist = prevData.some(item => item.productNumber === alternateProductNumber);

      if (isAlreadyExist) {
        toast.error("Product already exists!");
        return prevData;
      }
      // Replace the product number
      return prevData.map(item =>
        item.productNumber === originalItem
          ? { ...item, productNumber: alternateProductNumber, manufacturer: '' } // Replace only productNumber
          : item
      );
    });
  };



  const handleEdit = () => {
    if (!newPartNumber) return;

    const isDuplicate = productData.some(item => item.productNumber === newPartNumber);
    if (isDuplicate) {
      toast.error("This part number already exists!");
      return;
    }
    setProductData(prevData =>
      prevData.map(item =>
        item.productNumber === editingProduct
          ? { ...item, productNumber: newPartNumber }
          : item
      )
    );
    setEditingProduct(null);
  };

  const handleEditClick = (product) => {
    setEditingProduct(product);
    setNewPartNumber(product);
  };


  return (
    <>
      <NestedUserHeader
        index={`BOM Enquiry #${id}`}
        root="Dashboard"
        buttonText={'Add Subcategory'}
      />


      <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "8px", marginTop: "26px" }}>
        <Box sx={{ p: 2, }} display="flex" justifyContent="space-between" >
          <Box display="flex" alignItems="center" >
            <Typography style={{ marginLeft: '10px', fontSize: '18px', fontWeight: "600", }}>
              {productData?.length} Products
            </Typography>
            <Typography style={{ margin: '6px' }}>•</Typography>
            <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#4D4D4D' }}>
              Quoted date: {fomateDate(bomEnquiryDetails?.createdAt)}
            </Typography>
            <Typography style={{ margin: '6px' }}>•</Typography>
            <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600", color: bomEnquiryDetails?.status === "NEW" ? "#4A4C56" : bomEnquiryDetails?.status === "QUOTED" ? "#00B789" : "#1A9882" }}>
              {bomEnquiryDetails?.status}
            </Typography>
            {/* <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600", color: '#E9BD21' }}>
              Pending
            </Typography> */}
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <button type="button" className={styless.addBtn} style={{ position: 'static', padding: '8px 16px', fontSize: 14 }} onClick={handleOpenVendorPicker}>
              Vendor{selectedParts.length ? ` (${selectedParts.length})` : ''}
            </button>
            {bomEnquiryDetails?.status == "QUOTED" &&
              <ActionButton onClick={handleSubmit}> Edit Quote</ActionButton>
            }
          </Box>
        </Box>

        <div className={styless.quoteTables}>
          <div className={styless.quoteProductsPane}>

            <BomListTable
              products={updatedProducts}
              handleSelectAlternate={handleSelectAlternate}
              editingProduct={editingProduct}
              newPartNumber={newPartNumber}
              setNewPartNumber={setNewPartNumber}
              handleSubmit={handleEdit}
              handleEditClick={handleEditClick}
              selectable
              selectedProducts={selectedParts}
              onToggleSelect={handleToggleSelect}
              onToggleSelectAll={handleToggleSelectAll}
            />


          </div>
          <div className={styless.quoteInputsPane}>
            <table className={`${styless.productTable22} ${styless.quoteInputsTable}`}>
              <thead className={styless.productTableHead22}>
                <tr style={{ height: 30 }}>
                  <th className={styless.partNumber}>Quote price</th>
                  <th className={styless.partNumber}>MOQ</th>
                  <th className={styless.quoteActionHeader}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {productData?.map((product, index) => (
                  <tr key={product?._id}>
                    <td className={`${styless.requiredQuantity} ${styless.tdBorder}`}>
                      <input
                        type="text"
                        placeholder="Enter"
                        className={styless.dataInput}
                        value={product.quotePrice || ""} // Default empty if not present
                        onChange={(e) => handleChange(index, "quotePrice", e.target.value)}
                      />
                    </td>
                    <td className={`${styless.requiredQuantity} ${styless.tdBorder}`}>
                      <input
                        type="text"
                        placeholder="Enter"
                        className={styless.dataInput}
                        value={product.moq || ""} // Default empty if not present
                        onChange={(e) => handleChange(index, "moq", e.target.value)}
                      />
                    </td>

                    <td className={`${styless.requiredQuantity} ${styless.tdBorder} ${styless.quoteActionCell}`}>
                      <div className={styless.quoteActions}>
                        <button type="button" className={styless.quoteActionButton} aria-label="View product" onClick={() => handleView(index)}><View /></button>
                        <button type="button" className={styless.quoteActionButton} aria-label="Edit product" onClick={() => handleProductEdit(index)}>
                          <Edituser />
                        </button>
                        <button type="button" className={styless.quoteActionButton} aria-label="Refresh product" onClick={() => handleRefresh(index)}>
                          <Refresh />
                        </button>
                        <button type="button" className={styless.quoteActionButton} aria-label="Delete product" onClick={() => handleDelete(index)}>
                          <Close />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {bomEnquiryDetails?.status == 'NEW' &&
          <div style={{ display: 'flex', justifyContent: "flex-end", gap: "20px", padding: "20px" }}>
            <button className={styless.quoteBtn} onClick={handleCancel}>Cancel</button>
            <button className={styless.addBtn} onClick={handleSubmit}>Submit Quote</button>
          </div>
        }

      </Paper>

      {showVendorPicker &&
        <BomVendorPicker
          enquiryId={bomEnquiryDetails?._id}
          enquiryType={'BOM'}
          parts={partsToSend}
          onClose={() => setShowVendorPicker(false)}
          onSent={() => setSelectedParts([])}
        />
      }

      {showSupplier &&
        <div style={{ position: 'absolute', top: '20%', left: '30%', zIndex: 1, width: '100%' }}>
          <SuppliersQuote
            data={suppliers?.data}
            loading={suppliers?.loading}
            setShowSupplier={setShowSupplier}
            enquiryType={'BOM'}
            handleView={handleView}
            selectedIndex={selectedIndex}
          />
        </div>
      }
    </>
  );
};

export default BomQuote;
